/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPromotions200ResponseItemsInner } from './GetPromotions200ResponseItemsInner';
import {
    GetPromotions200ResponseItemsInnerFromJSON,
    GetPromotions200ResponseItemsInnerFromJSONTyped,
    GetPromotions200ResponseItemsInnerToJSON,
    GetPromotions200ResponseItemsInnerToJSONTyped,
} from './GetPromotions200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetPromotions200Response
 */
export interface GetPromotions200Response {
    /**
     * 
     * @type {Array<GetPromotions200ResponseItemsInner>}
     * @memberof GetPromotions200Response
     */
    items: Array<GetPromotions200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetPromotions200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetPromotions200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetPromotions200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetPromotions200Response interface.
 */
export function instanceOfGetPromotions200Response(value: object): value is GetPromotions200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetPromotions200ResponseFromJSON(json: any): GetPromotions200Response {
    return GetPromotions200ResponseFromJSONTyped(json, false);
}

export function GetPromotions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromotions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetPromotions200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetPromotions200ResponseToJSON(json: any): GetPromotions200Response {
    return GetPromotions200ResponseToJSONTyped(json, false);
}

export function GetPromotions200ResponseToJSONTyped(value?: GetPromotions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetPromotions200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

